export default __webpack_public_path__ + "/dist/images/logo.4ab572ec4a737a58a0959f1ede876e0e.svg";